import { CustomerIoAdapter } from "../CustomerIoAdapter/CustomerIoAdapter";
import { IAnalyticsAdapter } from "../IAnalyticsAdapter";
import { SegmentAdapter } from "../SegmentAdapter/SegmentAdapter";
import {
  AnalyticsOptions,
  AnalyticsProperties,
  AnalyticsTraits,
} from "../types";

export class AnalyticsService {
  private adapter: IAnalyticsAdapter;
  private customerIo: CustomerIoAdapter;

  constructor(adapter: IAnalyticsAdapter, customerIo: CustomerIoAdapter) {
    this.adapter = adapter;
    this.customerIo = customerIo;
  }

  track(
    event: string,
    properties: AnalyticsProperties,
    options?: AnalyticsOptions
  ): void {
    this.adapter.track(event, properties, options);
  }

  page(name: string, properties?: AnalyticsProperties): void {
    this.adapter.page(name, properties);
    this.customerIo.page(name, properties);
  }

  identify(userId: string, traits: AnalyticsTraits): void {
    this.adapter.identify(userId, traits);
    this.customerIo.identify(userId, traits);
  }

  reset(): void {
    this.adapter.reset();
    this.customerIo.reset();
  }
}

// Initialize Segment first so we can pass its track method to Customer.io
const segmentAdapter = new SegmentAdapter(
  import.meta.env.REACT_APP_SEGMENT_WRITE_KEY
);

const Analytics = new AnalyticsService(
  segmentAdapter,
  new CustomerIoAdapter(
    import.meta.env.REACT_APP_CUSTOMERIO_WRITE_KEY,
    import.meta.env.REACT_APP_CUSTOMERIO_SITE_ID,
    {
      // Pass Segment's track method so Customer.io in-app events get tracked
      segmentTrack: (event, properties) =>
        segmentAdapter.track(event, properties),
    }
  )
);

export default Analytics;
